<template>
	<div class="btn-group">
		<button-show v-bind:href="urlShow">
        </button-show>
        <button-edit v-bind:href="urlEdit">
        </button-edit>
        <button-delete v-bind:url="urlDelete">
        </button-delete>
       	<slot></slot>
	</div>
</template>
<script>
	export default{
		props: {
            edit: String,
            show: String,
            delete: String,
        },

        computed: {
            urlEdit: function () {
                return this.edit;
            },

            urlShow: function () {
                return this.show;
            },

            urlDelete: function () {
                return this.delete;
            },
        }
	}
</script>